import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface RunUserCodeRequest {
  userCode: string;
  inputs?: string[];
  sqlObjects?: { schemeSql: string; seedSql: string }[];
  language: string;
  questionProgramType: string;
  isThickClient?: boolean;
}

export interface RunUserCodeResponse {
  statusCode: number;
  httpStatus: string;
  response: RunUserCode;
  compilationError?: string;
  runtimeError?: string;
  templateError?: string;
  output?: string;
  finalOutput?: string;
  outputs?: { output?: string; error?: string; input: string }[];
}

export interface RunUserCode {
  totalEasyTestCases: number;
  totalMediumTestCases: number;
  totalHardTestCases: number;
  passedEasyTestCases: number;
  passedMediumTestCases: number;
  passedHardTestCases: number;
  totalTestCases: number;
  totalPassedTestCases: number;
  result: boolean;

  compilationError?: string;
  testCases?: {
    input: string;
    expectedOutput: string;
    actualOutput: string;
    result: boolean;
  }[];
  labels?: string[];
}

const BASE_URL: string = import.meta.env.VITE_TEST_FRESHERS_RUN_BASE_URL;

export const RunApiSlice = createApi({
  reducerPath: "runApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    runUserCode: builder.mutation<RunUserCodeResponse, RunUserCodeRequest>({
      query: (payload) => ({
        url: "/submissions/adder-run",
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useRunUserCodeMutation,
} = RunApiSlice;
